// built in
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types'
//external
import { Col, DatePicker, Form } from 'antd';
//internal
import styles from './styles'

const DateRangeSelect = ({
    handleDateRangeChange,
    dateRange
}) => {

    const { RangePicker } = DatePicker


    const [dates, setDates] = useState()
    const [hackValue, setHackValue] = useState()


    const disabledDate = useCallback(current => {
        if (!dates || dates.length === 0) {
            return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'months') >= 1
        const tooEarly = dates[1] && dates[1].diff(current, 'months') >= 1
        return tooEarly || tooLate
    })

    const onOpenChange = useCallback(open => {
        if (open) {
            setHackValue([])
            setDates([])
        } else {
            setHackValue(undefined)
        }
    })


    return (
        <Col>
            <Form.Item
                label={
                    <label style={styles.formLabel()}>
                        {`Time Period`.toUpperCase()}
                    </label>
                }>
                <RangePicker
                    style={styles.inputSize()}
                    onChange={handleDateRangeChange}
                    value={hackValue || dateRange}
                    onCalendarChange={val => setDates(val)}
                    disabledDate={disabledDate}
                    onOpenChange={onOpenChange}
                    allowClear={false}
                    format="DD MMM YYYY"
                />
            </Form.Item>
        </Col>
    )

}

DateRangeSelect.propTypes = {
    dateRange: PropTypes.array

}

DateRangeSelect.defaultProps = {
    dateRange: []
}

export default DateRangeSelect

